import { render } from "./NavbarGlobal.vue?vue&type=template&id=d855b9ca"
import script from "./NavbarGlobal.vue?vue&type=script&lang=js"
export * from "./NavbarGlobal.vue?vue&type=script&lang=js"

import "./NavbarGlobal.vue?vue&type=style&index=0&id=d855b9ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__